module.exports = __webpack_public_path__ + "static/primer-large-button-450465d9823ac380bdc281e719ce46df.png";